import React from 'react';
import S from './SkipToContent.styles';
const SkipToContent = ({ cta }) => {
    return (React.createElement(S.Link, { href: cta.url, "aria-label": cta.accessibleText }, cta.text));
};
export default SkipToContent;
